import { Router } from '@angular/router';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';

import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { CoreConfigService } from '@core/services/config.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-popup-restriction',
  templateUrl: './popup-restriction.component.html',
  styleUrls: ['./popup-restriction.component.scss']
})
export class PopupRestrictionComponent implements OnInit {

  
  public coreConfig: any;

  private _unsubscribeAll: Subject<any>;


  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   */
  constructor(private _coreConfigService: CoreConfigService, public modal: NgbActiveModal,  private _router: Router,) {
    this._unsubscribeAll = new Subject();

  }


  ngOnInit(): void {
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
    });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
  
  verf() {
   this.modal.close();
   
  }
}
